import { Box, SxProps, Typography } from "@mui/material"
import { TreeItem2Label } from "@mui/x-tree-view"
import { ElementType, ReactNode } from "react"

type LabelProps = {
  children: ReactNode
  icon?: ElementType
  sx?: SxProps
}

function Label({ icon: Icon, children, sx, ...props }: LabelProps) {
  return (
    <TreeItem2Label {...props} sx={{ display: "flex", alignItems: "center" }}>
      {Icon && (
        <Box
          component={Icon}
          className="labelIcon"
          color="inherit"
          sx={{ mr: 1, fontSize: "1.2rem" }}
        />
      )}
      <Typography variant="body2" sx={sx}>
        {children}
      </Typography>
    </TreeItem2Label>
  )
}

export default Label
